import type { ScheduleView } from '../types/scheduleView';

/** Every view, in the order the switcher shows them. */
export const SCHEDULE_VIEWS: readonly ScheduleView[] = ['month', 'week', 'threeDay', 'day'];

/** What the Schedule opens on when the coach never chose: the month, as it always did. */
export const DEFAULT_SCHEDULE_VIEW: ScheduleView = 'month';

/**
 * Reads the API's `scheduleDefaultView`. Absent (an older API), null or a value this build does not
 * know reads as month, so a deploy in either order never leaves the Schedule on a broken view.
 */
export const parseScheduleView = (value: unknown): ScheduleView =>
  typeof value === 'string' && (SCHEDULE_VIEWS as readonly string[]).includes(value)
    ? (value as ScheduleView)
    : DEFAULT_SCHEDULE_VIEW;

/** The switcher's label for a view. */
export const scheduleViewLabel = (view: ScheduleView): string => {
  switch (view) {
    case 'month':
      return 'Month';
    case 'week':
      return 'Week';
    case 'threeDay':
      return '3 days';
    case 'day':
      return 'Day';
  }
};

/** The unit Previous and Next move by, for their labels ("Previous week"). */
export const scheduleViewStep = (view: ScheduleView): string => {
  switch (view) {
    case 'month':
      return 'month';
    case 'week':
      return 'week';
    case 'threeDay':
      return '3 days';
    case 'day':
      return 'day';
  }
};

/** FullCalendar's view name for each view. `timeGridThreeDay` is defined on the calendar itself. */
export const FULLCALENDAR_VIEW: Record<ScheduleView, string> = {
  month: 'dayGridMonth',
  week: 'timeGridWeek',
  threeDay: 'timeGridThreeDay',
  day: 'timeGridDay',
};

/** Whether a view lays events out on a time axis (everything but the month). */
export const isTimeGridView = (view: ScheduleView): boolean => view !== 'month';
